import "./OurNationalPartners.css"

const OurNationalPartners = () => {
  return (
    <div>
      <div className="ournationalpartners" data-aos="fade-up"
        data-aos-duration="1000">
        <div className="ournationalpartners-heading">
          <h3>OUR national PARTNERS</h3>
          <hr />
        </div>
        <div className="ournationalpartners-img">
          <img src="./HomePhotos/OurNationalPartners/ourpartners1.png" alt="partners" />
          <img src="./HomePhotos/OurNationalPartners/avenueone.png" alt="partners" style={{ width: '180px' }} />
          {/* <img src="./HomePhotos/OurNationalPartners/ourpartners2.png" alt="partners" style={{ width: '170px' }} /> */}
          {/* <img src="./HomePhotos/OurNatinalPartners/ourpartners3.png" alt="partners" /> */}
          {/* <img src="./HomePhotos/OurNationalPartners/ourpartners4.jpeg" alt="partners" /> */}
          <img src="./HomePhotos/OurNationalPartners/ourpartners5.jpeg" alt="partners" style={{ width: '170px' }} />
          {/* <img src="./HomePhotos/OurNationalPartners/ourpartners6.png" alt="partners" style={{ width: '170px' }} /> */}
                    <img src="./HomePhotos/OurNationalPartners/ashirdeveloper.png" alt="partners" style={{ width: '150px' }} />
          <img src="./HomePhotos/OurNationalPartners/ourpartners7.png" alt="partners" style={{ width: '170px' }} />
          {/* <img src="./HomePhotos/OurNationalPartners/ourpartners8.png" alt="partners" style={{ width: '170px' }} /> */}
        </div>
      </div>
    </div>
  );
};

export default OurNationalPartners